import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'

const FilterBox = props => (
  <div className="filter-box">
    <div className="filter-content date filter-bold">
      <div className="filter-date">
        <div className="filter-title">
          Filter by Date Created
        </div>
        <div className="filter-body">
          <div className="filter-input">
            <div className="label-input">
              <span>Start Date</span>
            </div>
            <DatePicker
              className="input-date"
              selected={
                props.profile.filter.createStartDate ?
                moment(props.profile.filter.createStartDate) : null
              }
              onChange={props.setFilterValue('createStartDate', props.profile.filter, props.profile.sort)}
              isClearable
            />
          </div>
          <div className="filter-input relative">
            <span className="hyphen">-</span>
          </div>
          <div className="filter-input">
            <div className="label-input">
              <input
                className="checkbox-enddate"
                type="checkbox"
                onChange={props.setFilterValue('isCreateEndDateActive', props.profile.filter, props.profile.sort)}
                checked={props.profile.filter.isCreateEndDateActive}
              />
              <span>End Date</span>
            </div>
            <DatePicker
              className="input-date"
              selected={
                props.profile.filter.createEndDate ?
                moment(props.profile.filter.createEndDate) : null
              }
              onChange={props.setFilterValue('createEndDate', props.profile.filter, props.profile.sort)}
              isClearable
            />
          </div>
        </div>
      </div>
      <div className="filter-date">
        <div className="filter-title">
          Filter by Last Updated
        </div>
        <div className="filter-body">
          <div className="filter-input">
            <div className="label-input">
              <span>Start Date</span>
            </div>
            <DatePicker
              className="input-date"
              selected={
                props.profile.filter.lastUpdateStartDate ?
                moment(props.profile.filter.lastUpdateStartDate) : null
              }
              onChange={props.setFilterValue('lastUpdateStartDate', props.profile.filter, props.profile.sort)}
              isClearable
            />
          </div>
          <div className="filter-input relative">
            <span className="hyphen">-</span>
          </div>
          <div className="filter-input">
            <div className="label-input">
              <input
                className="checkbox-enddate"
                type="checkbox"
                onChange={props.setFilterValue('isLastUpdateEndDateActive', props.profile.filter, props.profile.sort)}
                checked={props.profile.filter.isLastUpdateEndDateActive}
              />
              <span>End Date</span>
            </div>
            <DatePicker
              className="input-date"
              selected={
                props.profile.filter.lastUpdateEndDate ?
                moment(props.profile.filter.lastUpdateEndDate) : null
              }
              onChange={props.setFilterValue('lastUpdateEndDate', props.profile.filter, props.profile.sort)}
              isClearable
            />
          </div>
        </div>
      </div>
    </div>
    <div className="filter-content search">
      <div className="search-bar">
        <input
          className="input"
          type="text"
          placeholder="Search by Profile ID / Name / Email"
          onChange={props.setFilterValue('profile', props.profile.filter, props.profile.sort)}
        />
      </div>
    </div>
  </div>
)

FilterBox.propTypes = {
  profile: PropTypes.shape({
    filter: PropTypes.shape({
      createStartDate: PropTypes.string,
      createEndDate: PropTypes.string,
      lastUpdateStartDate: PropTypes.string,
      lastUpdateEndDate: PropTypes.string,
      isCreateEndDateActive: PropTypes.bool,
      isLastUpdateEndDateActive: PropTypes.bool,
    }).isRequired,
    sort: PropTypes.shape({}).isRequired,
  }).isRequired,
  setFilterValue: PropTypes.func.isRequired,
}

export default FilterBox
